<template>
  <div>
    <Layout/>
    <h4>Referencia</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idReferencia" class="form-label">IdReferencia</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idReferencia" name="idReferencia" v-model="datoReferencia.idReferencia" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAtencion" name="idAtencion" v-model="datoReferencia.idAtencion">
                      <option v-for="atencion in atencions" :value="atencion.idAtencion" :key="atencion.idAtencion">
                        {{ atencion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idMotivoRef" class="form-label"> Motivo Ref</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMotivoRef" name="idMotivoRef" v-model="datoReferencia.idMotivoRef">
                      <option v-for="motivoRef in motivoRefs" :value="motivoRef.idMotivoRef" :key="motivoRef.idMotivoRef">
                        {{ motivoRef.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresaOrigen" class="form-label"> Empresa Origen</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEmpresaOrigen" name="idEmpresaOrigen" v-model="datoReferencia.idEmpresaOrigen">
                      <option v-for="empresaOrigen in empresaOrigens" :value="empresaOrigen.idEmpresaOrigen" :key="empresaOrigen.idEmpresaOrigen">
                        {{ empresaOrigen.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresaDestino" class="form-label"> Empresa Destino</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEmpresaDestino" name="idEmpresaDestino" v-model="datoReferencia.idEmpresaDestino">
                      <option v-for="empresaDestino in empresaDestinos" :value="empresaDestino.idEmpresaDestino" :key="empresaDestino.idEmpresaDestino">
                        {{ empresaDestino.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoReferencia.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMedico" name="idMedico" v-model="datoReferencia.idMedico">
                      <option v-for="medico in medicos" :value="medico.idMedico" :key="medico.idMedico">
                        {{ medico.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoReferencia.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaRef" class="form-label">FechaRef</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaRef" name="fechaRef" v-model="datoReferencia.fechaRef" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="hora" class="form-label">Hora</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="hora" name="hora" v-model="datoReferencia.hora" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoReferencia.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="motivo" class="form-label">Motivo</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="motivo" name="motivo" v-model="datoReferencia.motivo" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="resumen" class="form-label">Resumen</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="resumen" name="resumen" v-model="datoReferencia.resumen" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="hallazgos" class="form-label">Hallazgos</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="hallazgos" name="hallazgos" v-model="datoReferencia.hallazgos" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tratamiento" class="form-label">Tratamiento</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="tratamiento" name="tratamiento" v-model="datoReferencia.tratamiento" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="justificada" class="form-label">Justificada</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="justificada" name="justificada" v-model="datoReferencia.justificada" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarReferencia" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditReferencia" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdReferenciaDet</th>
          <th scope="col">IdReferencia</th>
          <th scope="col">IdDiagnostico</th>
          <th scope="col">Tipo</th>
          <th scope="col">Estado</th>
          <th scope="col">ReferenciaFechaReg</th>
          <th scope="col">DiagnosticoNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="referenciadet in datosPaginados" :key="referenciadet.idReferenciaDet">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(referenciadet.idReferenciaDet)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(referenciadet.idReferenciaDet)" title="Editar">edit_square</i></td>
          <td>{{referenciadet.idReferenciaDet}}</td>
          <td>{{referenciadet.idReferencia}}</td>
          <td>{{referenciadet.idDiagnostico}}</td>
          <td>{{referenciadet.tipo}}</td>
          <td>{{referenciadet.estado}}</td>
          <td>{{getFormattedDate(referenciadet.referenciaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{referenciadet.diagnosticoNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteReferencia(referenciadet.idReferenciaDet)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idReferenciaDet" class="form-label">IdReferenciaDet</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idReferenciaDet" name="idReferenciaDet" v-model="datoReferenciaDet.idReferenciaDet" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idReferencia" class="form-label">IdReferencia</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idReferencia" name="idReferencia" v-model="datoReferenciaDet.idReferencia" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idDiagnostico" class="form-label"> Diagnostico</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idDiagnostico" name="idDiagnostico" v-model="datoReferenciaDet.idDiagnostico">
                      <option v-for="diagnostico in diagnosticos" :value="diagnostico.idDiagnostico" :key="diagnostico.idDiagnostico">
                        {{ diagnostico.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoReferenciaDet.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarReferenciaDet" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditReferenciaDet" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
// Variables master
      referencias : [],
      datoReferencia : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idReferencia: '',
      atencions : [],
      motivoRefs : [],
      empresaOrigens : [],
      empresaDestinos : [],
      personas : [],
      medicos : [],
// Variables master
// Variables details
      referenciadets : [],
      datoReferenciaDet : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      diagnosticos : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idReferencia = this.$route.params.p_idreferencia
    this.abrirEditar(this.p_idReferencia)
    this.getDataPagina(this.paginaActual)
    this.fetchAtencions()
    this.fetchMotivoRefs()
    this.fetchEmpresaOrigens()
    this.fetchEmpresaDestinos()
    this.fetchPersonas()
    this.fetchMedicos()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idAtencion'
        ,'idMotivoRef'
        ,'idEmpresaOrigen'
        ,'idEmpresaDestino'
        ,'idPersona'
        ,'idMedico'
        ,'fechaRef'
        ,'hora'
        ,'tipo'
        ,'motivo'
        ,'resumen'
        ,'hallazgos'
        ,'tratamiento'
        ,'justificada'
      ];
      const requiredFieldsText = [
        'idAtencion'
        ,'idMotivoRef'
        ,'idEmpresaOrigen'
        ,'idEmpresaDestino'
        ,'idPersona'
        ,'idMedico'
        ,'fechaRef'
        ,'hora'
        ,'tipo'
        ,'motivo'
        ,'resumen'
        ,'hallazgos'
        ,'tratamiento'
        ,'justificada'
      ];
      return validarForm(this.datoReferencia, requiredFields, requiredFieldsText);
    },
    async guardarReferencia(){
      if(this.validarForm() === 1){
        try {
          await api.post('/referencias', this.datoReferencia)
          swal("Correcto!", "Referencia creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditReferencia(){
      if(this.validarForm() === 1){
        try {
          await api.post('/referencias', this.datoReferencia)
          swal("Correcto!", "Referencia creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoReferencia={}
      this.titulo   = 'Crear Referencia'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idReferencia){
      this.modalWindow = true
      if(idReferencia != null){    
           api.get('/vwreferencias/'+idReferencia).then(resp=>{
          this.datoReferencia = resp.data;
           });
      }
      this.titulo   = 'Editar Referencia'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarReferencia(){
      this.$router.push('/Referencia')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.referenciadets.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwreferenciadets/nombre/'+this.nombreBusqueda).then(response=>{
          this.referenciadets=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.referenciadets.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwreferenciadets').then(response=>{
      this.referenciadets=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.referenciadets.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idAtencion'
        ,'idMotivoRef'
        ,'idEmpresaOrigen'
        ,'idEmpresaDestino'
        ,'idPersona'
        ,'idMedico'
        ,'fechaRef'
        ,'hora'
        ,'tipo'
        ,'motivo'
        ,'resumen'
        ,'hallazgos'
        ,'tratamiento'
        ,'justificada'
      ];
      const requiredFieldsText = [
        'idAtencion'
        ,'idMotivoRef'
        ,'idEmpresaOrigen'
        ,'idEmpresaDestino'
        ,'idPersona'
        ,'idMedico'
        ,'fechaRef'
        ,'hora'
        ,'tipo'
        ,'motivo'
        ,'resumen'
        ,'hallazgos'
        ,'tratamiento'
        ,'justificada'
      ];
      return validarForm(this.datoReferencia, requiredFields, requiredFieldsText);
    },
    async guardarReferenciaDet(){
      if(this.validarForm() === 1){
        try {
          this.datoReferenciaDet.idReferencia = this.datoReferencia.idReferencia;
          await api.post('/referenciadets', this.datoReferenciaDet)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ReferenciaDet creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditReferenciaDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/referenciadets', this.datoReferenciaDet)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ReferenciaDet creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoReferenciaDet={}
      this.titulo   = 'Crear Referencia'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idReferenciaDet){
      this.modalWindow = true
      if(idReferenciaDet != null){    
           api.get('/vwreferenciadets/'+idReferenciaDet).then(resp=>{
          this.datoReferenciaDet = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Referencia'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idReferenciaDet){
      this.modalWindow = true
      if(idReferenciaDet != null){
        this.$router.push('/referenciadetmd/'+idReferenciaDet)
      }
    },
    async deleteReferenciaDet (idReferenciaDet) {
      try{
        await api.delete('/referenciadets/'+idReferenciaDet)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchAtencions() {
      fetch('http://localhost:8080/api/v1/atencions')
        .then(response => response.json())
        .then(data => {
          this.atencions = data;
        })
        .catch(error => {
          console.error('Error fetching atencions:', error);
        });
    },
    fetchMotivoRefs() {
      fetch('http://localhost:8080/api/v1/motivorefs')
        .then(response => response.json())
        .then(data => {
          this.motivoRefs = data;
        })
        .catch(error => {
          console.error('Error fetching motivoRefs:', error);
        });
    },
    fetchEmpresaOrigens() {
      fetch('http://localhost:8080/api/v1/empresaorigens')
        .then(response => response.json())
        .then(data => {
          this.empresaOrigens = data;
        })
        .catch(error => {
          console.error('Error fetching empresaOrigens:', error);
        });
    },
    fetchEmpresaDestinos() {
      fetch('http://localhost:8080/api/v1/empresadestinos')
        .then(response => response.json())
        .then(data => {
          this.empresaDestinos = data;
        })
        .catch(error => {
          console.error('Error fetching empresaDestinos:', error);
        });
    },
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
    fetchMedicos() {
      fetch('http://localhost:8080/api/v1/medicos')
        .then(response => response.json())
        .then(data => {
          this.medicos = data;
        })
        .catch(error => {
          console.error('Error fetching medicos:', error);
        });
    },
    fetchReferencias() {
      fetch('http://localhost:8080/api/v1/referencias')
        .then(response => response.json())
        .then(data => {
          this.referencias = data;
        })
        .catch(error => {
          console.error('Error fetching referencias:', error);
        });
    },
    fetchDiagnosticos() {
      fetch('http://localhost:8080/api/v1/diagnosticos')
        .then(response => response.json())
        .then(data => {
          this.diagnosticos = data;
        })
        .catch(error => {
          console.error('Error fetching diagnosticos:', error);
        });
    },
  },
}
</script>
